let _token = localStorage.getItem('token');

((open) => {
  XMLHttpRequest.prototype.open = function () {
    open.apply(this, arguments);
    if (_token) {
      this.setRequestHeader('x-access-token', _token); 
    }
  };
})(XMLHttpRequest.prototype.open);

export default {
  saveToken(token) {
    localStorage.setItem('token', token);
    _token = token;
  },
  clearToken() {
    localStorage.setItem('token', '');
    _token = null;
  }
};


// WEBPACK FOOTER //
// ./src/App/auth/TokenManager.js